import React, { useEffect, useRef, useState } from "react";
import "./Forms.css";
import {
  Col,
  Row,
  Container,
  Badge,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FormFilter } from "../../components/SearchFilter/FormFilter";
import { Link, useNavigate } from "react-router-dom";
import {
  DeleteCustomerApplication,
  GetCustomerAllApplicantForm,
  SendReminder,
} from "../../apis/FormAPI";
import { GetFormStatus } from "../../apis/MiscAPI";
import { confirmAlert } from "react-confirm-alert";
import dateFormat from "dateformat";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";

export default function Forms() {
  const {user} = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(9);
  const [formStatus, setFormStatus] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [isSearchedData, setIsSearchedData] = useState(false);
  const [isSorting, setIsSorting] = useState(false);

  const searchBody = useRef();

  const [sortingField, setSortingField] = useState(
    "customer_applicant_form_id"
  );
  const [sortingOrder, setSortingOrder] = useState("desc");

  const alert = useAlert();

  const loadMoreData = () => {
    setVisible((prevValue) => prevValue + 9);
  };
  const navigate = useNavigate();

  async function GetAllForms(oldlist) {
    let body = searchBody.current;
    var result = await GetCustomerAllApplicantForm(body);
    var formData = result.data;
    if (oldlist.length > 0 && !isSorting) {
      let list = JSON.parse(JSON.stringify(oldlist));
      list.push(...formData);
      setData(list);
    } else setData(formData);
    if (formData.length > 0) setTotalRecord(formData[0].totalRows);
  }

  useEffect(() => {
    GetFormStatuses();
  }, []);

  useEffect(() => {
    var pgSize = 9;
    var pgCount = pageCount;
    if (isSorting) {
      pgSize = pageCount * 9;
      pgCount = 1;
    }
    if (!isSearchedData) {
      searchBody.current = {
        pageNo: pgCount + "",
        pageSize: pgSize + "",
        user_id: user.userid,
        sortingField: sortingField,
        sortingOrder: sortingOrder,
      };
    } else searchBody.current.pageNo = pageCount + "";
    if (pageCount === 1) GetAllForms([]);
    else GetAllForms(data);
  }, [pageCount, sortingField, sortingOrder]);

  ///Filter
  async function GetFormStatuses() {
    var result = await GetFormStatus();
    setFormStatus(result.data);
  }

  useEffect(() => {
    if (visible < totalRecord) {
      setShowLoadMore(true);
    } else setShowLoadMore(false);
    if (visible / 9 > pageCount) setPageCount((prevValue) => prevValue + 1);
  }, [visible, totalRecord]);

  const handleSearch = async (searchValue) => {
    setPageCount(1);
    setIsSorting(false);
    searchValue === "" ? setIsSearchedData(false) : setIsSearchedData(true);
    searchBody.current = {
      applicant_name: searchValue,
      pageNo: "1",
      pageSize: "9",
      user_id: user.userid,
      sortingField: sortingField,
      sortingOrder: sortingOrder,
    };
    if (pageCount === 1) await GetAllForms([]);
  };

  const handleAdvanceSearch = async (searchData) => {
    setPageCount(1);
    setIsSearchedData(true);
    setIsSorting(false);
    let creationSearch = false;
    if (
      searchData.creationStartDate !== "" &&
      searchData.creationEndDate !== ""
    )
      creationSearch = true;

    let doSearch = false;

    if (
      creationSearch ||
      (searchData.applicantName != null && searchData.applicantName !== "") ||
      searchData.formStatus.statusId !== 0
    )
      doSearch = true;

    if (doSearch) {
      searchBody.current = {
        user_id: user.userid,
        creation_start_date:
          creationSearch === true
            ? dateFormat(searchData.creationStartDate, "yyyy-mm-dd")
            : "",
        creation_end_date:
          creationSearch === true
            ? dateFormat(searchData.creationEndDate, "yyyy-mm-dd")
            : "",
        applicant_name: searchData.applicantName,
        status:
          searchData.formStatus.statusId === 0
            ? ""
            : searchData.formStatus.statusId + "",
        pageNo: "1",
        pageSize: "9",
        sortingField: sortingField,
        sortingOrder: sortingOrder,
      };

      if (pageCount === 1) await GetAllForms([]);
    }
  };
  const StatusFilter = async (formStatus) => {
    setPageCount(1);
    setIsSearchedData(true);
    searchBody.current = {
      status: formStatus,
      pageNo: "1",
      pageSize: "9",
      user_id: user.userid,
    };
    if (pageCount === 1) GetAllForms([]);
  };

  const remiderClick = async (e) => {
    //console.log(e);
    var status = await SendReminder(e);
    // if (status) setShow(true);
    // else setShowWrongUser(true);

    if (status) alert.success("Reminder sent.");
    else alert.error("Something went wrong please try again.");
  };

  const deleteApplication = async (e, applicationId) => {
    confirmAlert({
      title: "Delete Form Request",
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "yesbtn",
          onClick: async () => {
            var result = await DeleteCustomerApplication(applicationId);
            if (result.status === 200) {
              let parentelem = e.target.parentNode.parentNode.parentNode;
              parentelem.style.display = "none";
              alert.success("Form request deleted");
            } else alert.error("Unable to delete form request");
          },
        },
        { label: "No", className: "nobtn" },
      ],
    });
  };

  const handleSorting = (sorting) => {
    setIsSorting(true);
    var sortingField = sorting.value;
    if (sortingField !== "") {
      let sort = sortingField.split(" ");
      setSortingField(sort[0]);
      setSortingOrder(sort[1]);
    } else {
      setSortingField("customer_applicant_form_id");
      setSortingOrder("desc");
    }
  };

  return (
    <>
      <Container>
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title forms-page-title">
              <h2>Forms</h2>
              <div className="quick-filter-top">
                <OverlayTrigger
                  overlay={
                    <Tooltip className="quick-filter-tooltip">
                      Quick filter by order status
                    </Tooltip>
                  }
                >
                  <button
                    type="button"
                    className="quick-filter-link"
                    onClick={() => StatusFilter("1")}
                  >
                    Sent
                  </button>
                </OverlayTrigger>
                <OverlayTrigger
                  overlay={
                    <Tooltip className="quick-filter-tooltip">
                      Quick filter by received status
                    </Tooltip>
                  }
                >
                  <button
                    type="button"
                    className="quick-filter-link"
                    onClick={() => StatusFilter("2")}
                  >
                    Received
                  </button>
                </OverlayTrigger>
                <OverlayTrigger
                  overlay={
                    <Tooltip className="quick-filter-tooltip">
                      Quick filter by ordered status
                    </Tooltip>
                  }
                >
                  <button
                    type="button"
                    className="quick-filter-link"
                    onClick={() => StatusFilter("3")}
                  >
                    Ordered
                  </button>
                </OverlayTrigger>
              </div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter">
              <FormFilter
                search={handleSearch}
                formStatuses={formStatus}
                customerid={user.customerid}
                investigatorid="0"
                advSearch={handleAdvanceSearch}
                displayShort={true}
                shortFields={[
                  { text: "Applicant ↑ ", value: "applicant_name asc" },
                  { text: "Applicant ↓ ", value: "applicant_name desc" },
                  { text: "Form No ↑", value: "form_no asc" },
                  { text: "Form No ↓", value: "form_no desc" },
                  { text: "Form Name ↑", value: "form_name asc" },
                  { text: "Form Name ↓", value: "form_name desc" },
                  { text: "Date Created ↑", value: "created_date asc" },
                  { text: "Date Created ↓", value: "created_date desc" },
                  { text: "Status ↑", value: "form_status_id asc" },
                  { text: "Status ↓", value: "form_status_id desc" },
                ]}
                sortOrder={handleSorting}
              />
            </div>
          </Col>
        </Row>
        <Row className="quick-filter-badge-row">
          <Col>
            <div className="quick-filter-badge">
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip className="quick-filter-tooltip">
                    Send a new webform application to a prospective
                  </Tooltip>
                }
              >
                <Badge
                  bg="secondary"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/Customer/CreditApplicationForm")}
                >
                  New Application
                </Badge>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip className="quick-filter-tooltip">
                    Create a new order with PDF/JPEG attachments only
                  </Tooltip>
                }
              >
                <Badge
                  bg="secondary"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/Customer/SubmitOrder")}
                >
                  New Order Without Webform Application
                </Badge>
              </OverlayTrigger>
            </div>
          </Col>
        </Row>
        <Row className="reports-card-row forms-cards">
          {data.length > 0 ? (
            data.slice(0, visible).map((item) => (
              <Col lg={4} md={6} sm={12}>
                <div className="cards">
                  {item.formStatusId !== 3 ? (
                    <button
                      className="form-card-delete"
                      onClick={(e) => deleteApplication(e, item.id)}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  ) : (
                    ""
                  )}
                  <div className="cards-body">
                    <div className="cards-text">
                      <div className="cards-list-group">
                        <div className="cards-list-item">
                          <span>Applicant: </span>
                          {item.applicantName}
                        </div>
                        <div className="cards-list-item">
                          <span>RE: </span>
                          {item.orderRE}
                        </div>
                        <div className="cards-list-item">
                          <span>Form No: </span>
                          {item.formNo}
                        </div>
                        <div className="cards-list-item">
                          <span>Form Name: </span>
                          {item.formName}
                        </div>
                        <div className="cards-list-item">
                          <span>Date Created: </span>
                          {item.creationDate}
                        </div>
                        <div className="cards-list-item">
                          <span>Status: </span>
                          {item.formStatusName}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="reports-action-btn">
                    {item.formTemplateId != 0 ? (
                      <Link
                        className="cards-link"
                        to={`/Form?token=view&id=${item.formTemplateId}&applicationid=${item.id}`}
                        target="_blank"
                      >
                        View Form
                      </Link>
                    ) : (
                      ""
                    )}

                    <button
                      onClick={() => remiderClick(item.id)}
                      className={
                        item.formStatusId === 1
                          ? "cards-link"
                          : "cards-link-hide"
                      }
                    >
                      Send Reminder
                    </button>
                    <button
                      className={
                        item.formStatusId === 2
                          ? "cards-link"
                          : "form-order-btn"
                      }
                      onClick={() =>
                        navigate("/Customer/ApplicationWebForm?id=" + item.id)
                      }
                    >
                      Order
                    </button>
                    <button
                      className={
                        item.formStatusId === 3
                          ? "cards-link"
                          : "cards-link-hide"
                      }
                      onClick={() =>
                        navigate("/Customer/OrdersDetails?id=" + item.orderId)
                      }
                    >
                      View Order
                    </button>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <p>No results found</p>
          )}
        </Row>
        <div
          className={
            showLoadMore ? "text-center my-5" : "text-center my-5 hide-div"
          }
        >
          <button onClick={loadMoreData} className="btn-load-more">
            Load More...
          </button>
        </div>
      </Container>
    </>
  );
}
